import { generateRootObjectSchema, generateArraySchema, generateObjectSchema, generateStringSchema, generateColorSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ImageParticleSpec, TextParticleSpec, SegmentedButtonParticleSpec } from "components/cards/particles/YinzCam";


export const specification = new BaseAtomSpec("MC-LineupTable2", generateRootObjectSchema({
    container: generateAtomContainerSchema(),
    overlayPadding: generateStringSchema('Container Padding', 'Container Padding'),
    headerTabs: SegmentedButtonParticleSpec.generateSchema('Header Tabs', 'Header Tabs'),
    homeTeamLogoImg: ImageParticleSpec.generateSchema('Home Team Logo', 'Home Team Logo', {
        defaultValues: { container: { width: '4rem', height: '4rem' }, sizing: 'cover' },
    }),
    awayTeamLogoImg: ImageParticleSpec.generateSchema('Away Team Logo', 'Away Team Logo', {
        defaultValues: { container: { width: '4rem', height: '4rem' }, sizing: 'cover' },
    }),
    homeTxtTeamName: TextParticleSpec.generateSchema('Home Team Name', 'Home Team Name', {
        defaultValues: { size: '1.25rem', weight: '600' },
    }),
    awayTxtTeamName: TextParticleSpec.generateSchema('Away Team Name', 'Away Team Name', {
        defaultValues: { size: '1.25rem', weight: '600' },
    }),
    txtLineUp: TextParticleSpec.generateSchema('Starters Heading', 'Starters Heading', {
        defaultValues: { size: '1rem', weight: '400', align: 'center' },
    }),
    txtSubHeading: TextParticleSpec.generateSchema('Substitutes Heading', 'Substitutes Heading', {
        defaultValues: { size: '2rem', weight: '700', align: 'center', text: 'Substitutes' },
    }),
    playerImage: ImageParticleSpec.generateSchema('Player Image', 'Player Image', {
        defaultValues: { container: { height: '2.5rem' }, sizing: 'cover', fitVerticalAlign: 'top' },
    }),
    homePlayerStarterStats: generateArraySchema(
        'Home Starter Player Stats',
        'Home Starter Player Stats',
        generateObjectSchema('Enter Player Stats', 'Enter Player Stats', {
            position: TextParticleSpec.generateSchema('Player Position', 'Player Position', {
                defaultValues: { size: '3rem', weight: '700', align: 'right' },
            }),
            playerName: TextParticleSpec.generateSchema('Player name', 'Player name', {
                defaultValues: { size: '1.25rem', weight: '400' },
            }),
            playingPosition: TextParticleSpec.generateSchema('Playing Position', 'Playing Position', {
                defaultValues: { size: '1rem', weight: '400' },
            }),
            playerImageUrl: generateStringSchema('Image Url', 'Image Url'),
        })
    ),
    awayPlayerStarterStats: generateArraySchema(
        'Away Starter Player Stats',
        'Away Starter Player Stats',
        generateObjectSchema('Enter Player Stats', 'Enter Player Stats', {
            position: TextParticleSpec.generateSchema('Player Position', 'Player Position', {
                defaultValues: { size: '3rem', weight: '700', align: 'right' },
            }),
            playerName: TextParticleSpec.generateSchema('Player name', 'Player name', {
                defaultValues: { size: '1.25rem', weight: '400' },
            }),
            playingPosition: TextParticleSpec.generateSchema('Playing Position', 'Playing Position', {
                defaultValues: { size: '1rem', weight: '400' },
            }),
            playerImageUrl: generateStringSchema('Image Url', 'Image Url'),
        })
    ),
    homePlayerSubStats: generateArraySchema(
        'Home Substitute Player Stats',
        'Home Substitute Player Stats',
        generateObjectSchema('Enter Player Stats', 'Enter Player Stats', {
            position: TextParticleSpec.generateSchema('Player Position', 'Player Position', {
                defaultValues: { size: '3rem', weight: '700', align: 'right' },
            }),
            playerName: TextParticleSpec.generateSchema('Player name', 'Player name', {
                defaultValues: { size: '1.25rem', weight: '400' },
            }),
            playingPosition: TextParticleSpec.generateSchema('Playing Position', 'Playing Position', {
                defaultValues: { size: '1rem', weight: '400' },
            }),
            playerImageUrl: generateStringSchema('Image Url', 'Image Url'),
        })
    ),
    awayPlayerSubStats: generateArraySchema(
        'Away Substitute Player Stats',
        'Away Substitute Player Stats',
        generateObjectSchema('Enter Player Stats', 'Enter Player Stats', {
            position: TextParticleSpec.generateSchema('Player Position', 'Player Position', {
                defaultValues: { size: '3rem', weight: '700', align: 'right' },
            }),
            playerName: TextParticleSpec.generateSchema('Player name', 'Player name', {
                defaultValues: { size: '1.25rem', weight: '400' },
            }),
            playingPosition: TextParticleSpec.generateSchema('Playing Position', 'Playing Position', {
                defaultValues: { size: '1rem', weight: '400' },
            }),
            playerImageUrl: generateStringSchema('Image Url', 'Image Url'),
        })
    ),
    teamTricode: generateStringSchema('Tricode', 'Tricode'),
    numberColor: generateColorSchema('Player Number Color', 'Player Number Color'),
    homeTeamPlayerImages: generateArraySchema(
        'Home Player Images',
        'Home Player Images',
        generateStringSchema('Image URLs', 'Image URLs')
    ),
    awayTeamPlayerImages: generateArraySchema(
        'Away Player Images',
        'Away Player Images',
        generateStringSchema('Image URLs', 'Image URLs')
    ),
}));